module.exports = __webpack_public_path__ + "img/20210828_213653.200e81cc.jpg";